import React, { useEffect } from "react";
import { HomeMonthlyTrendWrapper } from "./HomeMonthlyTrendStyle";
import HomeContentSubTitle from "./HomeContentSubTitle";
import { HomeCreators } from "redux/modules/home";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "components/common/Spinner";
import { useNavigate } from "react-router-dom";
import { DashBoardCreators } from "redux/modules/dashboard";

const HomeMonthlyTrend = () => {
  const dispatch = useDispatch();
  const monthlyTrendList = useSelector((state) => state.home.monthlyTrendList);
  const thisMonth = new Date().getMonth() + 1;
  const navigate = useNavigate();
  const isMonthlyTrendLoading = useSelector(
    (state) => state.home.isMonthlyTrendLoading
  );

  useEffect(() => {
    dispatch(HomeCreators.fetchMonthlyTrendData());
  }, []);

  const navigateSearchDetail = (name) => {
    new Promise((res, rej) => {
      const result = dispatch(
        DashBoardCreators.fetchSearchData({ page: 0, name })
      );
      res(result);
    }).then((res) => {
      const { f_id, f_name, f_type, pred_b, pred_p } = res.payload.data[0];
      navigate(`/dashboard/${f_id}/${f_type}/${f_name}/${pred_p}/${pred_b}`);
    });
  };

  if (!isMonthlyTrendLoading) {
    return (
      <HomeMonthlyTrendWrapper>
        <HomeContentSubTitle
          title={`${thisMonth}월의 꽃 트렌드`}
          routingTitle="꽃 검색하기"
          path="/dashboard"
        />
        <Spinner width="200" height="200" />
      </HomeMonthlyTrendWrapper>
    );
  }

  return (
    <HomeMonthlyTrendWrapper>
      <HomeContentSubTitle
        title={`${thisMonth}월의 꽃 트렌드`}
        routingTitle="꽃 검색하기"
        path="/dashboard"
      />

      <div className="content-wrapper">
        <ul className="monthly-trend-content">
          {monthlyTrendList?.slice(0, 3).map((item) => {
            return (
              <li
                key={item.flowersId}
                onClick={() => navigateSearchDetail(item.flowerName)}
              >
                <p className="monthly-trend-content-rank">{item.r_num}</p>
                <span>
                  <p>{item.flowerType}</p>
                  <p>{item.flowerName}</p>
                </span>
              </li>
            );
          })}
        </ul>
        <ul className="monthly-trend-content">
          {monthlyTrendList?.slice(3, 6).map((item) => {
            return (
              <li
                key={item.flowersId}
                onClick={() => navigateSearchDetail(item.flowerName)}
              >
                <p className="monthly-trend-content-rank">{item.r_num}</p>
                <span>
                  <p>{item.flowerType}</p>
                  <p>{item.flowerName}</p>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </HomeMonthlyTrendWrapper>
  );
};

export default HomeMonthlyTrend;
